// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f010ae68","455":"3309e33e","977":"77cf22b6"}[chunkId] + ".chunk.js";
};